<template>
  <el-container class="app-container">
    <el-header><Header /></el-header>
    <el-container>
      <el-aside
        class="app-aside"
        v-if="showAsideMenu"
        :width="[menuCollapse, $i18n.locale] | asideWidth"
      >
        <el-scrollbar
          class="app-aside-scrollbar"
          :native="true"
          :wrap-style="scrollWrapStyle"
          wrap-class="app-aside-scrollbar__wrap"
        >
          <el-menu
            router
            :default-active="menuDefault"
            :background-color="menuBgColor"
            :text-color="menuTextColor"
            :active-text-color="menuActiveTextColor"
          >
            <template v-for="item in layoutMenu">
              <template v-if="authMenu[item.code] && !item.hidden">
                <child-menu
                  v-if="item.children && item.children.length > 0"
                  :key="item.id"
                  :index="item.id"
                  :subMenu="item"
                ></child-menu>
                <template v-else>
                  <el-menu-item v-if="item.click" :key="item.id" :index="item.id">
                    <div @click="item.click" class="menu-class">
                      <em :class="item.icon"></em>
                      <span>{{ $t(item.title) }}</span>
                    </div>
                  </el-menu-item>
                  <el-menu-item v-if="item.href" :key="item.id" :index="item.id">
                    <a :href="item.href" target="_blank" class="menu-class">
                      <em :class="item.icon"></em>
                      <span>{{ $t(item.title) }}</span>
                    </a>
                  </el-menu-item>
                  <el-menu-item
                    v-else-if="item.route"
                    :key="item.id"
                    :index="item.route.path || item.id"
                    :route="item.route"
                  >
                    <div class="menu-class">
                      <em :class="item.icon"></em>
                      <span>{{ $t(item.title) }}</span>
                    </div>
                  </el-menu-item>
                </template>
              </template>
            </template>
          </el-menu>
        </el-scrollbar>
      </el-aside>
      <el-main class="app-content" id="appContent">
        <Content />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import Content from './content';
import { notice } from './notice';
import ctt from '@/utils/const';
import { isMobile } from '@/utils/is';

import Header from './header';
import { debounce } from 'lodash';

let msgList = [];
const maxLen = 3;

const handler = debounce(function (fn) {
  fn?.();
}, 500);

export default {
  name: 'Layout',
  sockets: {
    '/socket/alarm'(res) {
      this.handleAlarmMsg(res);
    }
  },
  methods: {
    handleAlarmMsg(res) {
      if (res.code !== ctt.WS_DANGE1 && res.code !== ctt.WS_DANGE2) return;

      handler(() => {
        if (msgList.length >= maxLen) {
          msgList.shift()?.close();
        }

        if (this.authMenu['010499']) msgList.push(notice.call(this, 'ALARM', res));
      });
    },
    // mock1Handle() {
    //   let obj = {
    //     code: ctt.WS_DANGE1,

    //     eventData: {
    //       beginTime: '2025-08-07 14:39:33',
    //       officeName: '黑盒子测试',
    //       deviceType: 'CR1224',
    //       deviceName: '射线报警器',
    //       sn: '202506211604',
    //       message: '核辐射剂量报警；设备报警'
    //     }
    //   };

    //   let timer = setInterval(() => {
    //     if (msgList.length >= maxLen) clearInterval(timer);

    //     this.handleAlarmMsg(obj);
    //   }, 1000);
    // },

    deleteHandle() {
      msgList[0].close?.();
      msgList.shift();
    }
  },
  components: {
    Header,
    Content,
    ChildMenu: () => import('./child-menu')
  },
  filters: {
    asideWidth([val, locale]) {
      const config = [
        [['es'], '320px'],
        [['en'], '280px'],
        [['ru', 'fr'], '340px'],
        [['zh-CN', 'ar'], '190px']
      ];

      const width = config.find(([keys]) => keys.includes(locale))[1];

      return val ? '0' : width || '200px';
    }
  },
  provide() {
    return {
      showAsideMenu: this.showAsideMenu
    };
  },
  computed: {
    ...mapState('app', ['isLocal', 'menuCollapse', 'validAlarmNotice', 'theme']),
    ...mapState('admin', ['authMenu', 'profile']),
    ...mapGetters('admin', ['layoutMenu']),
    menuBgColor() {
      return this.theme === 'light' ? '#ffffff' : '#0c1620';
    },
    menuTextColor() {
      return this.theme === 'light' ? '#595959' : '#B1FFFC';
    },
    menuActiveTextColor() {
      return this.theme === 'light' ? '#1890ff' : '#00eeff';
    },
    showAsideMenu() {
      return this.authMenu['010215'];
    },
    scrollWrapStyle() {
      const val = isMobile() ? 'unset' : '-17px';
      return {
        marignRight: val,
        marignBottom: val
      };
    },
    menuDefault() {
      const { path, meta, params } = this.$route;
      if (meta.activeMenu) return meta.activeMenu;
      if (!isEmpty(params)) {
        return path
          .split('/')
          .filter(e => !Object.values(params).includes(e) && !/%/.test(e))
          .join('/');
      }
      return path;
    }
  },
  mounted() {
    // this.mock1Handle();
  }
};
</script>

<style lang="scss">
.remote-monitor {
  height: 100%;
  display: flex;
  padding: 1px;
}
.app-container {
  background-color: var(--layout-app-bg);
  background-image: var(--layout-app-bg-image);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  .el-header {
    padding: 0;
  }
  .el-main {
    height: calc(100vh - 60px);
    padding: 0;
  }
  .app-aside-scrollbar {
    height: calc(100vh - 60px);
    .app-aside-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .app-aside {
    min-height: calc(100vh - 60px);
  }
  .el-aside {
    position: relative;
    overflow: hidden; // 隐藏的时候出现了滚动条
    transition: width 0.2s ease-in;
    background-color: var(--aside-bg);
    box-shadow: 1px 0 0 var(--aside-shadow-color);
    .el-menu {
      border-right: none;
      em {
        display: inline-block;
        color: var(--menu-icon-color);
        font-size: 16px;
        vertical-align: middle;
        margin-right: 5px;
        width: 24px;
        text-align: center;
      }
      .el-menu-item {
        .menu-class {
          color: inherit;
          text-decoration: none;
          display: inline-block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .show-class {
    > .el-aside {
      width: 300px;
    }
  }
  .hidden-class {
    > .el-aside {
      width: 0;
    }
  }
}
</style>
